import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useForm, Controller } from 'react-hook-form';
import { Card, Button } from '@mui/material';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import * as actions from '../../redux/actions';
import { BackButton } from '../../components/Button';
import { MaterialForm } from '../../components/Forms';
import { Loading } from '../../components/Loading';
import { Error } from '../../components/Error';
import { ViewTitle } from '../../components/ViewTitle';
import place from '../../utils/constants/place.constant';
import { Inventory } from '@mui/icons-material';

const defaultValues = {
  type_code: '',
  name: '',
  unit: '',
  material_type: '',
  net: '',
  unit_net: '',
  minimum_amount: '',
  detail: '',
  customer_type: '',
  register_number: '',
};
export default function CreateMaterial({ title, subtitle }) {
  const dispatch = useDispatch();
  const material = useSelector((state) => state.material);
  const materialType = useSelector((state) => state.materialType);
  const customerType = useSelector((state) => state.customerType);
  const customer = useSelector((state) => state.customer);
  const place = useSelector((state) => state.place);
  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
    watch,
  } = useForm();
  const history = useHistory();

  const [selectCustomerType, setSelectCustomerType] = useState();
  const [selectCustomer, setSelectCustomer] = useState([]);
  const [image, setImage] = useState([]);
  useEffect(() => {
    dispatch(actions.materialAll({}));
    dispatch(actions.materialTypeAll(''));
    dispatch(actions.customerTypeAll({}));
    dispatch(actions.placeAll({}));
    return () => {};
  }, []);

  useEffect(() => {
    if (selectCustomerType) {
      dispatch(actions.customerAll({ customerType: selectCustomerType }));
    }
    return () => {};
  }, [selectCustomerType]);

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  const onSubmit = async (data) => {
    try {
      // เพิ่มชื่อประเภทสินค้าให้กับแต่ละแถว
      if (materialType && Array.isArray(materialType.rows)) {
        data.materialType = {
          rows: materialType.rows.map((type, idx) => ({
            status: data.materialType?.rows?.[idx]?.status ?? false,
            name: type.name,
            id: type._id,
          })),
        };
      }

      if (!_.isEmpty(image)) {
        data.image = {
          image: image?.[0]?.data_url,
          imageType: 'profile',
          alt: '',
        };
      }

      // --- แปลงข้อมูลให้อยู่ในรูปแบบแจกแจงแต่ละรายการ ---
      // 1. ดึงประเภทสินค้าที่เลือก (status: true)
      const selectedTypes = _.filter(_.get(data, 'materialType.rows', []), {
        status: true,
      });

      // 2. ดึงคลังที่เลือก (status: true)
      const selectedPlaces = _.keys(
        _.pickBy(_.get(data, 'place', {}), (v) => v.status === true),
      );

      // 3. สร้าง array ของแต่ละ combination
      const materialList = [];
      _.forEach(selectedTypes, (type) => {
        _.forEach(selectedPlaces, (place) => {
          materialList.push({
            name: data.name,
            isbar: data.isbar,
            material_type: type.id,
            place: {
              name: place,
              status: true,
            },
            inventory: 0,
            weight: 0,
          });
        });
      });

      // --- ส่งข้อมูลไป backend ---
      await dispatch(actions.materialCreate({ arr: materialList }));
      alert('สำเร็จ');
      reset(defaultValues);
      history.goBack();
    } catch (error) {
      console.error(error);
    }
  };

  if (material.isLoading) {
    return <Loading />;
  }

  if (!material.isLoading && material.isCompleted) {
    return (
      <div>
        {renderTitle()}
        <div className="flex flex-row justify-start pb-4">
          <div>
            <BackButton />
          </div>
        </div>
        <div>
          <Card className="p-4">
            <form onSubmit={handleSubmit(onSubmit)}>
              <MaterialForm
                errors={errors}
                material={material}
                place={place}
                control={control}
                Controller={Controller}
                materialType={materialType}
                customerType={customerType}
                watch={watch}
                selectCustomerType={selectCustomerType}
                setSelectCustomerType={setSelectCustomerType}
                customer={customer}
                setSelectCustomer={setSelectCustomer}
                selectCustomer={selectCustomer}
                image={image}
                setImage={setImage}
              />
              <div className="flex flex-row justify-end gap-1 py-4">
                <Button variant="contained" type="submit">
                  บันทึก
                </Button>
              </div>
            </form>
          </Card>
        </div>
      </div>
    );
  }

  return <Error message={material?.message} />;
}

CreateMaterial.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

CreateMaterial.defaultProps = {
  title: '',
  subtitle: '',
};
